import React, { useMemo, useState } from 'react';

import { SettingInfo } from '@components/card-control/settings/modals/InfoModal';
import { SpendingLimitCategory } from '@components/card-control/types';

import CardControlContext, { ICardControlContext } from './CardControlContext';

interface Props {
    children: React.ReactNode;
}

export const CardControlContextProvider: React.FC<Props> = ({ children }) => {
    const [selectedCategory, selectCategory] = useState<SpendingLimitCategory | null>(null);
    const [selectedInfoModal, selectInfoModal] = useState<SettingInfo | null>(null);

    const removeSelectedCategory = () => selectCategory(null);
    const closeInfoModal = () => selectInfoModal(null);

    const cardControlContext: ICardControlContext = useMemo(
        () => ({
            selectedCategory,
            selectCategory,
            removeSelectedCategory,

            selectedInfoModal,
            selectInfoModal,
            closeInfoModal,
        }),
        [selectedCategory, selectedInfoModal],
    );

    return <CardControlContext.Provider value={cardControlContext}>{children}</CardControlContext.Provider>;
};
